// extracted by mini-css-extract-plugin
module.exports = {"content":"InstitutionDetails_content__kRucd","grid":"InstitutionDetails_grid__1n5m3","fullWidth":"InstitutionDetails_fullWidth__JzEIs"};